import { create } from 'zustand';
import _ from 'lodash';

interface initDataState {
  param: any;
  bindParam: any;
  result: any;
  initPayload: any;
  payload: any;
  bind: (result: { data: any }) => void;
  bindPayload: (payload: { data: any }) => void;
}

// 주택 자금저축
export const initSettlementPayload = {
  total: {
    totDeterminedPaid: 0, //결정세액
    totPrePaid: 0, //기납세액
    totPayablePaid: 0, //차감징수세액
    totRefundPaid: 0, //환급/납부
  },
  result: {},
};

// 주택 자금저축
export const initSettlementNtsPayload = {
  list: [
    {
      id: 'insurance_health_pension',
      category: '국민연금/건강보험료(추가납부)',
      nts_amt: 0,
      manual_amt: 0,
      import_amt: 0,
    },
    {
      id: 'creditcard',
      category: '신용카드 등',
      nts_amt: 0,
      manual_amt: 0,
      import_amt: 0,
    },
    {
      id: 'insurance',
      category: '상세보험료',
      nts_amt: 0,
      manual_amt: 0,
      import_amt: 0,
    },
    {
      id: 'medical',
      category: '의료비',
      nts_amt: 0,
      manual_amt: 0,
      import_amt: 0,
    },
    {
      id: 'education',
      category: '교육비',
      nts_amt: 0,
      manual_amt: 0,
      import_amt: 0,
    },
    {
      id: 'donation',
      category: '기부금',
      nts_amt: 0,
      manual_amt: 0,
      import_amt: 0,
    },
    {
      id: 'housing',
      category: '주택공제',
      nts_amt: 0,
      manual_amt: 0,
      import_amt: 0,
    },
    {
      id: 'pension_savings',
      category: '연금저축',
      nts_amt: 0,
      manual_amt: 0,
      import_amt: 0,
    },
    {
      id: 'others',
      category: '기타입력',
      nts_amt: 0,
      manual_amt: 0,
      import_amt: 0,
    },
  ],
};

/**
  정산결과
**/
export const settlementDataStore = create<initDataState>(set => ({
  param: { initialSeq: 0 },
  bindParam: (bind: any) =>
    set(state => ({
      ...state,
      param: { ...state.param, ...bind },
    })),
  result: [],
  bind: (data: any) =>
    set(state => ({
      ...state,
      result: { ...state.result, ...data },
    })),
  initPayload: initSettlementPayload,
  payload: initSettlementPayload,
  bindPayload: (data: any) =>
    set(state => ({
      ...state,
      payload: { ...state.payload, ...data },
    })),
}));

/**
  정산결과
**/
export const settlementNtsDataStore = create<initDataState>(set => ({
  param: { initialSeq: 0 },
  bindParam: (bind: any) =>
    set(state => ({
      ...state,
      param: { ...state.param, ...bind },
    })),
  result: [],
  bind: (data: any) =>
    set(state => ({
      ...state,
      result: { ...state.result, ...data },
    })),
  initPayload: initSettlementNtsPayload,
  payload: _.cloneDeep(initSettlementNtsPayload),
  bindPayload: (data: any) =>
    set(state => ({
      ...state,
      payload: { ...state.payload, ...data },
    })),
}));

/**
  정산결과
**/
export const ntsFileDataStore = create<initDataState>(set => ({
  param: { initialSeq: 0 },
  bindParam: (bind: any) =>
    set(state => ({
      ...state,
      param: { ...state.param, ...bind },
    })),
  result: [],
  bind: (data: any) =>
    set(state => ({
      ...state,
      result: { ...state.result, ...data },
    })),
  initPayload: initSettlementNtsPayload,
  payload: _.cloneDeep(initSettlementNtsPayload),
  bindPayload: (data: any) =>
    set(state => ({
      ...state,
      payload: { ...state.payload, ...data },
    })),
}));
